<template>
  <section class="container-fluid">
    <div class="row p-md-4 pb-md-0 p-3 h-100">
      <div class="border-around p-3">
        <header-help />

        <div class="col-md-3 col-12 mx-auto">
          <div class="login-card">
            <div class="login-body">
              <form method="#" action="#" class="my-1">
                <div class="row">
                  <div class="col-md-12">
                    <div class="content-creator-container">
                      <div class="content-creator-p">
                        <p class="font-family-poppins">If you're trying to subscribe to a creator, please return to the
                          link they shared. This is to
                          sign up as a Content Creator</p>
                      </div>
                    </div>
                    <h2 class="text-white font-size-24 font-family-poppins mt-4" style="text-align: center;">Content
                      Creator Sign Up</h2>
                  </div>
                  <div class="col-md-12 my-4 text-center">
                    <img src="@/assets/images/stella/no_avatar.png" class="img-fluid upload-img" id="avatar"
                      onclick="$('#file_upload').trigger('click')" style="cursor:pointer;">
                    <div style="white-space: nowrap;cursor:pointer;" class="font-grey mt-2"
                      onclick="$('#file_upload').trigger('click')">Add a photo
                    </div>
                    <input type="file" class="form-control d-none" id="file_upload" name="file" ref="file"
                      @change="handleFileUpload()" accept="image/*">
                  </div>
                </div>
                <global-message></global-message>
                <div class="form-group">
                  <label for="name" class="font-grey">Name
                  </label>
                  <div class="input-group flex-nowrap ">
                    <input type="text" class="form-control stella-group " name="name" v-model.lazy="user.name">
                  </div>
                  <div class="danger invalid-feedback" v-if="isRequired('name')">This is required field</div>
                </div>
                <div class="form-group">
                  <div class="form-group">
                    <label for="url" class="font-grey">Customize URL
                    </label>
                    <div class="custom-form-control">
                      <input type="text" class="form-control url-input" name="url" v-model="user.urlSuffix">
                      <input type="text" class="form-control url-input-show" name="url-show" readonly
                        :value="`${constructCustomerBaseURL}/${user.urlSuffix ? user.urlSuffix : ''}`">
                    </div>
                    <div class="danger invalid-feedback" v-if="isRequired('urlSuffix')">This is required field</div>
                  </div>
                  <!--                    <div class="input-group flex-nowrap stella-group">
                                        &lt;!&ndash; <input type="text"
                                               class="form-control url-input" name="url" v-model="user.urlSuffix">
                                        <input type="text" class="form-control url-input-show" name="url-show" readonly
                                               :value="`${constructCustomerBaseURL}/${user.urlSuffix? user.urlSuffix: ''}`"> &ndash;&gt;
                                        <span class="input-group-text pe-0" >
                                          stella.so/
                                        </span>
                                        <input type="text" class="form-control px-0 font-gradient-a font-weight-bold" v-model="user.urlSuffix" placeholder="">
                                        <span class="input-group-text ps-0 pe-3">
                                          <img class="img-fluid"  src="@/assets/images/stella/green-check.png" style="width:45px">
                                          &lt;!&ndash; <img class="img-fluid"  src="@/assets/images/stella/invalid-check.png" style="width:45px"> &ndash;&gt;
                                        </span>
                                      </div>-->

                  <div class="input-group flex-nowrap stella-group custom-form-control ">
                  </div>
                </div>

                <div class="form-group">
                  <label for="email" class="font-grey">Email
                  </label>
                  <div class="input-group flex-nowrap">
                    <input id="email" type="text" class="form-control stella-group" name="email"
                      v-model.lazy="user.email">
                  </div>
                  <div class="danger invalid-feedback" v-if="isRequired('email')">This is required field</div>
                  <div class="danger invalid-feedback" v-if="isValidEmail()">Not a valid email address</div>
                </div>
                <div class="form-group">
                  <div class="d-block">
                    <label for="password" class="font-grey">Password
                    </label>
                  </div>
                  <div class="input-group flex-nowrap stella-group">
                    <input autocomplete="false" placeholder="Enter your password" type="password" id="password"
                      style="color: #212529 !important;" class="form-control stella-group" name="password"
                      v-model.lazy="user.password">
                    <!-- onclick="show_password()"                        -->
                    <div class="input-group-text">
                      <i id="show_id" class="fa fa-eye" @click="showPassword('password')"></i>
                      <i id="hide_id" class="fa fa-eye-slash d-none"></i>
                    </div>
                  </div>
                  <div class="danger invalid-feedback" v-if="isRequired('password')">This is required field</div>
                </div>
              </form>
            </div>
          </div>
          <div class="row justify-content-center mx-md-0 mx-1 mb-5">
            <div class="col-md-12 col-12 px-1 ">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" name="agree-to-terms" class="custom-control-input" tabindex="3"
                  id="agree-to-terms">
                <label for="agree-to-terms" class="custom-control-label font-size-12">By signing up you are agreeing to
                  our <a href="" class="text-white font-weight-500" @click.prevent="goTo('TermsOfService')">Terms of
                    Service</a> and <a href="" class="text-white font-weight-500"
                    @click.prevent="goTo('PrivacyPolicy')">Privacy Policy</a></label>
              </div>

              <button type="submit" class="btn stella-btn gradient-a w-100 rounded-pill font-weight-700 mt-4"
                @click="createAccount()">Create an Account
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import { email, required } from "vuelidate/lib/validators";
import { httpMixin } from "@/mixin/http-mixin";
import HeaderHelp from "./shared/HeaderHelp";
import { showPassword } from '@/common/Utils'
import { constructCustomerBaseURL } from "@/common/baseURL-service";
import { SERVICE_IDENTIY } from "@/properties/micro-service";
import GlobalMessage from "@/components/module/shared/GlobalMessage";
import titleMixin from "../../../mixin/title-mixin";

export default {
  name: 'CreateAccountMobile',
  title: 'Creator create account',
  components: { HeaderHelp, GlobalMessage },
  mixins: [httpMixin, titleMixin],
  data() {
    return {
      user: {},
      file: '',
      someValue: ''
    }
  },
  validations: {
    user: {
      name: { required },
      urlSuffix: { required },
      email: { required, email },
      password: { required }
    }
  },
  created() {
    console.log(this.$refs.file);
    this.clearGlobalMessages();
    console.log(this.getAgentName());
    if (this.getAgentName()) {
      this.getUnSecureData(`${SERVICE_IDENTIY}/api/v1/agency/name/${this.getAgentName()}`, (data) => {
        console.log(data);
        this.user.agency = data;
      });
    }

  },
  computed: {
    constructCustomerBaseURL
  },
  methods: {
    ...mapActions(['setUser', 'setImageFile', 'clearGlobalMessages']),
    ...mapGetters(['getAgentName']),
    goTo(to) {
      this.$router.push({ name: to });
    },
    showPassword,
    isRequired(attrib) {
      return this.isLoading && !this.$v.user[attrib].required;
    },
    isValidEmail() {
      return this.isLoading && !this.$v.user.email.email;
    },
    handleFileUpload() {
      console.log(this.$refs.file.files[0]);
      $("#avatar").attr("src", URL.createObjectURL(this.$refs.file.files[0]));
      this.setImageFile(this.$refs.file.files[0]);
    },
    createAccount() {
      this.isLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      let url = `${SERVICE_IDENTIY}/api/v1/influencers/preCheck`;
      this.postUnsecureData(url, this.user, (data) => {
        this.setUser(this.user);
        this.$router.push({ name: 'Platforms' });
      });


    }
  }
}
  ;
</script>

<style scoped>
.content-creator-container {
  background: #fdf2c9;
  border-radius: 15px;
  width: 100%;

}

.content-creator-p {

  padding-top: 14px;
  padding-bottom: 2px;
  padding-left: 8px;
  font-size: popins;
  padding-right: 8px;

}

.content-creator-p p {

  font-weight: 500;
  font-family: 16px;
  color: #1e1c18;
}
</style>
